<div class="flex flex-col gap-2" [attr.data-testid]="testId()">
  <div
    class="grid grid-cols-[minmax(0,1fr)_auto] sm:grid-cols-[minmax(0,1fr)_7rem_10rem] gap-3 items-center px-3 text-sm text-muted-color"
  >
    <span>{{ 'project.steps.criteriaWeightsOverview.criterion' | transloco }}</span>
    <span class="text-right">{{ 'project.steps.criteriaWeightsOverview.weight' | transloco }}</span>
    <span class="hidden sm:block text-right">
      {{ 'project.steps.criteriaWeightsOverview.overallWeight' | transloco }}
    </span>
  </div>

  @for (row of rows(); track row.criterion.id) {
    <button
      type="button"
      class="grid grid-cols-[minmax(0,1fr)_auto] sm:grid-cols-[minmax(0,1fr)_7rem_10rem] gap-3 items-center w-full p-3 bg-third-level rounded-lg text-left cursor-pointer"
      [attr.aria-expanded]="row.expanded"
      [attr.data-testid]="testId() + '-criterion-' + row.criterion.id"
      (click)="toggleCriterion(row.criterion.id)"
    >
      <span class="flex items-center gap-3 min-w-0">
        <i class="text-xs shrink-0" [class]="row.toggleIcon"></i>
        <span
          class="hidden sm:block size-3 rounded-full shrink-0"
          [style.background-color]="row.criterion.color"
        ></span>
        <span class="flex flex-1 flex-col sm:flex-row sm:items-center sm:gap-3 min-w-0">
          <span class="text-sm shrink-0">{{ row.criterion.identifier }}</span>
          <span class="font-medium break-words sm:truncate">
            {{ row.criterion.translations | translateDirectus }}
          </span>
        </span>
      </span>
      <span
        class="text-right font-medium tabular-nums text-button-red"
        [attr.data-testid]="testId() + '-criterion-weight-' + row.criterion.id"
      >
        {{ row.criterion.weight | criteriaWeight }}
      </span>
      <span class="hidden sm:block text-right tabular-nums">
        {{ row.criterion.weight | criteriaWeight }}
      </span>
    </button>

    @if (row.expanded) {
      <div
        class="flex flex-col gap-1 pl-4 sm:pl-8"
        [attr.data-testid]="testId() + '-sub-criteria-' + row.criterion.id"
      >
        @for (subCriterion of row.criterion.subCriteria; track subCriterion.id) {
          <div
            class="grid grid-cols-[minmax(0,1fr)_auto] sm:grid-cols-[minmax(0,1fr)_7rem_10rem] gap-3 items-center p-3 bg-second-level rounded-lg"
            [attr.data-testid]="testId() + '-sub-criterion-' + subCriterion.id"
          >
            <span class="flex flex-1 flex-col sm:flex-row sm:items-center sm:gap-3 min-w-0">
              <span class="text-sm shrink-0">{{ subCriterion.identifier }}</span>
              <span class="break-words sm:truncate">
                {{ subCriterion.translations | translateDirectus }}
              </span>
            </span>
            <span
              class="text-right tabular-nums text-button-red"
              [attr.data-testid]="testId() + '-sub-criterion-weight-' + subCriterion.id"
            >
              {{ subCriterion.weight | criteriaWeight }}
            </span>
            <span
              class="hidden sm:block text-right tabular-nums"
              [attr.data-testid]="testId() + '-sub-criterion-overall-weight-' + subCriterion.id"
            >
              {{ subCriterion.overallWeight | criteriaWeight }}
            </span>
          </div>
        } @empty {
          <div class="p-3 text-sm text-muted-color">
            {{ 'project.steps.criteriaWeightsOverview.noSubCriteria' | transloco }}
          </div>
        }
      </div>
    }
  }
</div>
